import gql from 'graphql-tag';

const GET_USERS_LIST = gql`
  query GetUsersList($params: ListUsersInput!) {
    listUsers(params: $params) {
      users {
        username
        userStatus
        userCreateDate
        attributes {
          sub
          email
          givenName
          familyName
          merchantName
          userType
          userRole
          identities
        }
      }

      paginationToken
    }
  }
`;

export default GET_USERS_LIST;
